<template lang="pug">
  .container.grid-lg.py-2
    load-manager(:status='status')
      .card(v-if='form')
        .card-body
          form-group(:label="'doc_publicacao.descricao' | tModel" :validation='$v.form.descricao')
            input.form-input(type='text' v-model='$v.form.descricao.$model' :placeholder="'doc_publicacao.descricao' | tModel")
          .columns
            .column.col-auto
              form-group(:label="'doc_publicacao.numero' | tModel" :validation='$v.form.numero')
                int.form-input(type='text' v-model='$v.form.numero.$model' :placeholder="'doc_publicacao.numero' | tModel")
            .column.col-auto
              form-group(:label="'doc_publicacao.ano' | tModel" :validation='$v.form.ano')
                year.form-input(v-model='$v.form.ano.$model' :placeholder="'doc_publicacao.ano' | tModel")
            .column
              form-group(:label="'doc_publicacao.publicado_em' | tModel" :validation='$v.form.publicado_em')
                datepicker(v-model='$v.form.publicado_em.$model' :placeholder="'doc_publicacao.publicado_em' | tModel")
        .card-footer
          .columns
            .column
              a.btn.btn-link(@click="$router.back()")
                btn-content(name='back')
            .column.col-auto
              button.btn.btn-primary(:class="{'loading': loading}", @click='save', :disabled='$v.$invalid || loading')
                btn-content(name='save')
</template>

<script>
import DocPublicacao from '@/models/DocPublicacao'

export default {
  vuex: {
    'fiscalizacao/docPublicacoes': {
      state: ['status'],
      getters: ['loading'],
      actions: ['fetchOne', 'fetchUpdate'],
    },
  },
  data() {
    return { form: null }
  },
  methods: {
    save() {
      const id = this.$route.params.id
      const params = this.form.postParams
      this.fetchUpdate({ id, params })
        .then(res => {
          this.$toaster.success('Salvo com sucesso.')
          this.$router.back()
        })
        .catch(e => {
          this.$toaster.error(this.$parseErrors(e).join(', '))
        })
    },
  },
  validations: {
    form: DocPublicacao.validations,
  },
  created() {
    if (this.current) {
      this.form = new DocPublicacao(this.current)
    } else {
      return this.fetchOne(this.$route.params.id).then(res => {
        this.form = new DocPublicacao(res)
      })
    }
  },
}
</script>
